export default __webpack_public_path__ + "static/media/visual-data.49c28596.svg";